<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";

export default {
  components: {
    Layout,
    VclList,
  },
  data() {
    return {
      loading: true,
      errored: false,
      list: [],
      categories: [],
      statuses: [],
      filter: {
        protocol: "",
        status: "",
        category: "",
      },
    };
  },
  computed: {
    statusOptions() {
      return [{ value: "", text: "Todos os status" }].concat(
        this.statuses.map((row) => ({ value: row.id, text: row.name }))
      );
    },
    categoryOptions() {
      return [{ value: "", text: "Todas as categorias" }].concat(
        this.categories.map((row) => ({ value: row.id, text: row.name }))
      );
    },
    hasFilter() {
      return this.filter.protocol !== "" || this.filter.status !== "" || this.filter.category !== "";
    },
  },
  methods: {
    getOptions() {
      api.get("ticket/categories").then((response) => {
        if (response.data.status == "success") {
          this.categories = response.data.categories;
          this.statuses = response.data.statuses;
        }
      });
    },
    getTickets() {
      this.loading = true;
      this.errored = false;

      api
        .get("ticket", {
          params: {
            protocol: this.filter.protocol,
            status: this.filter.status,
            category: this.filter.category,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.list = response.data.list;
          } else {
            this.list = [];
          }
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearFilter() {
      this.filter.protocol = "";
      this.filter.status = "";
      this.filter.category = "";
      this.getTickets();
    },
    badgeStyle(row) {
      const color = row.ticket_status && row.ticket_status.color ? row.ticket_status.color : "#74788d";
      return { backgroundColor: color, color: "#fff" };
    },
  },
  mounted() {
    this.getOptions();
    this.getTickets();
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex justify-content-between align-items-center">
          <h3 class="mb-0">Fale Conosco</h3>
          <router-link to="/contact/new" class="btn btn-default btn-sm text-uppercase">
            <i class="bx bx-plus font-size-16 align-middle mr-1"></i> Nova solicitação
          </router-link>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <b-form class="row" @submit.prevent="getTickets">
          <div class="col-md-4 mb-2">
            <b-form-input v-model="filter.protocol" type="text" placeholder="Buscar protocolo" autocomplete="off"></b-form-input>
          </div>
          <div class="col-md-3 mb-2">
            <b-form-select v-model="filter.status" :options="statusOptions" @change="getTickets"></b-form-select>
          </div>
          <div class="col-md-3 mb-2">
            <b-form-select v-model="filter.category" :options="categoryOptions" @change="getTickets"></b-form-select>
          </div>
          <div class="col-md-2 mb-2 d-flex">
            <b-button type="submit" variant="default" class="flex-fill">Buscar</b-button>
            <b-button v-if="hasFilter" variant="link" class="ml-1" @click="clearFilter">Limpar</b-button>
          </div>
        </b-form>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <vcl-list v-if="loading" class="col-lg-6"></vcl-list>
        <div v-else-if="errored" class="text-center py-4">
          <p>Não foi possível carregar suas solicitações.</p>
          <b-button variant="default" size="sm" @click="getTickets">Tentar novamente</b-button>
        </div>
        <div v-else-if="list.length === 0" class="text-center py-4">
          <p class="mb-2">{{ hasFilter ? "Nenhuma solicitação encontrada." : "Nenhuma solicitação ainda" }}</p>
          <router-link v-if="!hasFilter" to="/contact/new" class="btn btn-default btn-sm">Nova solicitação</router-link>
        </div>
        <div v-else>
          <div class="table-responsive d-none d-md-block">
            <table class="table table-centered table-nowrap table-hover mb-0">
              <thead class="thead-light">
                <tr>
                  <th>Protocolo</th>
                  <th>Categoria</th>
                  <th>Assunto</th>
                  <th>Status</th>
                  <th>Atualizado em</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in list" :key="row.id">
                  <td class="notranslate"><strong>{{ row.protocol }}</strong></td>
                  <td>{{ row.category.name || "—" }}</td>
                  <td class="text-wrap">{{ row.subject }}</td>
                  <td>
                    <span class="badge badge-pill font-size-12" :style="badgeStyle(row)">{{ row.ticket_status.name }}</span>
                  </td>
                  <td class="notranslate">{{ row.updated }}</td>
                  <td class="text-right">
                    <router-link :to="'/contact/' + row.id" class="btn btn-default btn-sm btn-rounded">
                      Ver <i class="mdi mdi-arrow-right ml-1"></i>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-md-none">
            <router-link
              v-for="row in list"
              :key="'m' + row.id"
              :to="'/contact/' + row.id"
              class="d-block border rounded p-3 mb-2 text-body"
            >
              <div class="d-flex justify-content-between align-items-start">
                <strong class="notranslate">{{ row.protocol }}</strong>
                <span class="badge badge-pill font-size-12" :style="badgeStyle(row)">{{ row.ticket_status.name }}</span>
              </div>
              <div class="mt-1">{{ row.subject }}</div>
              <small class="text-muted">{{ row.category.name || "—" }} · {{ row.updated }}</small>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
